<template>
  <div class="careers" id="careers">
    <div class="careers__container">
        <div class="careers__texture">
            <img src="@/assets/img/careers/careers-texture.svg" alt="" />
        </div>
      <h1>We hired people who are Always Passionate about what they do</h1>
      <p>
        Through True Rich Attended does no end it his mother since real had half
        every him case in packages enquire we up ecstatic unsatiable saw .
      </p>
      <img src="@/assets/img/careers/careers-text.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>